import React from 'react';

type TreatmentOverviewProps = {
  title: string;
  description: string;
};

export const TreatmentOverview: React.FC<TreatmentOverviewProps> = ({
  title,
  description,
}) => (
  <div className="flex flex-col gap-1">
    <span className="text-md font-semibold">{title}</span>
    <span className="text-sm text-gray-500">{description}</span>
  </div>
);
